import {
	ADD_FILTER, CLEAR_FILTER, LOAD_ALL_PARTIES, PORTFOLIO_HOLDINGS_TAB
} from './../Actions/index';

const initialState = {
	applied_filter: {
		party: {},
		collection: {},
		age_range: {
			min: 0,
			max: 0
		},
		short_by: ""
	},
	fillter_applied: false,
	portfolioHoldingTab: 'current',
	allParties: []
};

const FilterReducer = (state = initialState, action) => {
	switch (action.type) {
		case ADD_FILTER:
			let tmp_filter = {
				party: action.payload.filter.party ? action.payload.filter.party : {},
				collection: action.payload.filter.collection ? action.payload.filter.collection : {},
				age_range: action.payload.filter.age_range ? action.payload.filter.age_range : {min: 0, max: 0},
				short_by: action.payload.filter.short_by ? action.payload.filter.short_by : ""
			}
			return {
				...state,
				applied_filter: tmp_filter,
				fillter_applied: true
			}
		case CLEAR_FILTER:
			let init_applied_filter = {
				party: {},
				collection: {},
				age_range: {
					min: 0,
					max: 0
				},
				sort_by: ""
			}
			return {
				...state,
				wallet_data: init_applied_filter,
				fillter_applied: false
			}
		case PORTFOLIO_HOLDINGS_TAB:
			return {
				...state,
				portfolioHoldingTab: action.payload.data
			}
		case LOAD_ALL_PARTIES:
			return {
				...state,
				allParties: action.payload.data
			}
		default:
			return state
	}

};

export default FilterReducer;

